import { borderRadius, dominant, form, transparentize } from "@glossy";
import { onDominant } from "@glossy/theme";
import { GlossyTheme } from "@glossy/theme/types";

export default (theme: GlossyTheme, firstMount?: boolean) => {
  const props = { theme, firstMount };
  return {
    control: (styles, state) => ({
      ...styles,
      minHeight: 48,
      cursor: "text",
      padding: "0 7px",
      ...borderRadius("bottom", state.menuIsOpen ? 0 : 8),
      ...borderRadius("top", 8),
      borderColor:
        state.isFocused || firstMount
          ? dominant(props)
          : transparentize(0.5, form(props, "primary")),
      backgroundColor: "transparent",
      boxShadow:
        (state.isFocused || firstMount) && `inset 0 0 0 1px ${dominant(props)}`,
      transition: null,
      ":hover": {
        borderColor:
          state.isFocused || firstMount
            ? dominant(props)
            : form(props, "primary"),
      },
    }),
    input: (styles) => ({
      ...styles,
      color: form(props, "primary"),
    }),
    placeholder: (styles) => ({
      ...styles,
      color: transparentize(0.3, form(props, "primary")),
    }),
    option: (styles, state) => ({
      ...styles,
      backgroundColor:
        state.isFocused && transparentize(0.85, form(props, "primary")),
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 12px",
      height: "48px",
      cursor: "pointer",
      marginTop: -2,
      color: form(props, "primary"),
    }),
    menu: (styles) => ({
      ...styles,
      marginTop: -2,
      backgroundColor: onDominant(props),
      boxShadow: null,
      border: `2px solid ${dominant(props)}`,
      borderTop: `1px solid ${transparentize(0.5, form(props, "primary"))}`,
      maxHeight: 194,
      ...borderRadius("bottom", 8),
      ...borderRadius("top", 0),
    }),
    menuList: (styles) => ({
      ...styles,
      height: 170,
      marginBottom: 4,
    }),
  };
};
